import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import SEO from "../../components/common/SEO";
import {
  generateOrganizationSchema,
  generateWebApplicationSchema,
} from "../../utils/seo/structuredData";
import {
  Header,
  Hero,
  Features,
  CallToAction,
  HowItWorks,
  Footer,
} from "../../components/landing-page";

const LandingPage = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleGetStarted = () => {
    loginWithRedirect({
      appState: { returnTo: "/home" },
    });
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [generateOrganizationSchema(), generateWebApplicationSchema()],
  };

  return (
    <div className="flex flex-col min-h-screen bg-light-grey">
      <SEO
        title="DayShift MMA - UFC Fantasy League Platform | Compete with Friends"
        description="Join the ultimate UFC fantasy league platform. Create leagues with friends, compete globally, build your fighter lineup, and dominate the octagon. Free to play!"
        keywords="UFC fantasy, MMA fantasy league, UFC picks, fantasy fighting, UFC competition, MMA predictions, fantasy sports, UFC lineup, fantasy MMA, UFC fantasy draft"
        url="/"
        structuredData={structuredData}
      />

      <Header
        isScrolled={isScrolled}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        isAuthenticated={isAuthenticated}
        handleGetStarted={handleGetStarted}
        loginWithRedirect={loginWithRedirect}
      />

      <div className="pt-16 sm:pt-24">
        <Hero handleGetStarted={handleGetStarted} />

        <Features handleGetStarted={handleGetStarted} />

        <CallToAction handleGetStarted={handleGetStarted} />

        <HowItWorks handleGetStarted={handleGetStarted} />

        <Footer handleGetStarted={handleGetStarted} />
      </div>
    </div>
  );
};

export default LandingPage;
